import { defineMessages } from 'react-intl';

export default defineMessages({
  fleetLoginModalText: {
    id: 'PostLoginPopupManager.modalText',
    defaultMessage:
      'You can now seamlessly check-out with your FleetPerform account on Parts To Go with AuroraPay.'
  },
  learnMore: {
    id: 'PostLoginPopupManager.learnMore',
    defaultMessage: 'Learn more about AuroraPay:'
  },
  downloadButtonText: {
    id: 'PostLoginPopupManager.downloadButtonText',
    defaultMessage: 'AuroraPay Documentation'
  },
  pdfFileName: {
    id: 'PostLoginPopupManager.pdfFileName',
    defaultMessage: 'AuroraPay_HowTo_PTG_Fleet.pdf'
  }
});
